import { Card, Col } from "react-bootstrap"

export const HomeCards =(props)=>{
    return(
      props.cards.map((card, i)=>(
        <Col md={3} className="mb-4" key={i}>
        <Card className="h-100">
        <Card.Img variant='top' src={card.image} className="card-img"/>
        <Card.Body className="d-flex flex-column">
          <Card.Title>{card.title}</Card.Title>
          <Card.Text>{card.text}</Card.Text>
        </Card.Body>
        </Card>
      </Col>
      )) 
    )
  }